module.exports = __webpack_public_path__ + "img/202310_08.795cd0e2.jpg";